import React from "react";

const taxAnswerEntry = props => {
  return (
    <div style={styles.container}>
      <div style={styles.headingStyle}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            marginLeft: "2px"
          }}
        >
          {props.heading}
          {props.currency}
        </div>
      </div>

      <div style={styles.numberStyle}>
        <p>{props.value}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row"
  },
  headingStyle: {
    display: "flex",
    alignItems: "center",
    width: "50%",
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#ccc",
    height: 40,
    paddingLeft: "15px"
  },
  numberStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "50%",
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#ccc",
    height: 40,
    paddingRight: "15px"
  }
};

export default taxAnswerEntry;
